module.exports = __webpack_public_path__ + "img/check-green.49e9c8e5.svg";